import { render, staticRenderFns } from "./oralSurgeryTest.vue?vue&type=template&id=0d6c830f&scoped=true&"
import script from "./oralSurgeryTest.vue?vue&type=script&lang=js&"
export * from "./oralSurgeryTest.vue?vue&type=script&lang=js&"
import style0 from "./oralSurgeryTest.vue?vue&type=style&index=0&id=0d6c830f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6c830f",
  null
  
)

export default component.exports